import axios from 'axios'
import qs from "qs"
import {
	Toast
} from 'vant'
import router from '@/router'
import api from "../interface/index"
import {
	Dialog
} from 'vant';

let loadingCount = 0;

export const showLoading = () => {
	if (loadingCount <= 0) {
		Toast.loading({
			// mask: true,
			duration: 20000
		})
	}
	loadingCount++
}

export const hideLoading = () => {
	loadingCount--;
	if (loadingCount <= 0) {
		Toast.clear()
		loadingCount = 0
	}
};

// 语言代码映射函数
const mapLanguage = (lang) => {
	const languageMap = {
		'zh': 'zh_cn',
		'zh-CN': 'zh_cn',
		'zh-cn': 'zh_cn',
		'zh_CN': 'zh_cn',
		'en': 'en_us',
		'en-US': 'en_us', 
		'en-us': 'en_us',
		'en_US': 'en_us',
		'ja': 'ja_jp',
		'ja-JP': 'ja_jp',
		'ja-jp': 'ja_jp',
		'ja_JP': 'ja_jp',
		'ko': 'ko_kr',
		'ko-KR': 'ko_kr',
		'ko-kr': 'ko_kr',
		'ko_KR': 'ko_kr',
		'th': 'th_th',
		'th-TH': 'th_th',
		'th-th': 'th_th',
		'th_TH': 'th_th',
		'vi': 'vi_vn',
		'vi-VN': 'vi_vn',
		'vi-vn': 'vi_vn',
		'vi_VN': 'vi_vn',
		'ms': 'ms_my',
		'ms-MY': 'ms_my',
		'ms-my': 'ms_my',
		'ms_MY': 'ms_my'
	}
	return languageMap[lang] || lang || 'zh_cn'
}

export default async (url, data, opt, isLoad = true) => {
	let lang = "zh_cn";

	if (isLoad) {
		showLoading();
	}

	url = api.commonUrl + "/api" + url;
	const set = {
		method: 'post',
		...opt
	};
	var token = localStorage.getItem('token');
	
	// 使用映射后的语言代码
	var rawLanguage = localStorage.getItem("lang") || "zh_cn";
	var language = mapLanguage(rawLanguage);
	
	return (set.method === 'post' ? axios.post(url, {
		...data,
		token,
		language
	}) : axios.get(url + '?' + qs.stringify({
		...data,
		token,
		language  // GET 请求也要添加 language 参数
	}))).then(r => {

		if (isLoad) {
			hideLoading();
		}

		if (r.status === 200 && r.data.code) {
			return r.data;
		}

		if (r.data.code === 0) {
			return r.data;
		}

		throw {
			msg: '网络错误，请稍后重试'
		};

	}).then(r => {

		if (r.code === 1) {
			return r
		} else {

			if (r.code === 0) {
				throw {
					msg: r.info
				}
			}

			if (!r.code) {
				throw {
					msg: '网络错误，请稍后重试！'
				}
			}

			if (r.code === 406) {
				router.push('/setpaypwd');
			}

			if (r.code === 405) {
				const current = {
					...router.currentRoute
				};
				router.push('/authEmail?redirect=' + current.path+"?id="+current.query.id+"&money="+current.query.money);
			}

			if (r.code === 410) {
				router.push('/setpaypwd');
			}

			if (r.code === 403 || r.code === 401) {

				if (r.code === 401) {
					localStorage.setItem('reset_time', 0);
				}

				const current = {
					...router.currentRoute
				};
				if (current && current.path !== '/' && !(['/', '/reg', '/forgetpwd'].includes(current
					.path))) {
					if (current.path !== '/login') {
						router.replace('/login?redirect=' + current.path)
					}
				}
			}
		}

		throw r;

	}).catch(r => {

		if (isLoad) {
			hideLoading();
		}

		// 使用映射后的语言代码获取当前语言
		var currentLanguage = mapLanguage(localStorage.getItem("lang") || "zh_cn");
		var message = '网络错误，请稍后或更换网络重试！';

		if (r.info) {
			// 处理多语言错误信息
			if (typeof r.info === 'object' && r.info[currentLanguage]) {
				message = r.info[currentLanguage];
			} else if (typeof r.info === 'string') {
				message = r.info;
			}
		}

		if (r.msg) {
			// 处理多语言错误信息
			if (typeof r.msg === 'object' && r.msg[currentLanguage]) {
				message = r.msg[currentLanguage];
			} else if (typeof r.msg === 'string') {
				message = r.msg;
			}
		}
		
		// 增加一个判断，有返回值才弹窗，防止页面未加载完按返回时提示网络错误
		if (isLoad && (r.info || r.msg)) {
			Dialog.alert({
				message: message,
				confirmButtonText: window.vm ? window.vm.$i18n.t('utils.confirm') : '确定'
			});
		}

		throw r;
	})
}